import type { InlineInputProps, SelectOption } from '@ztechapps/webui.input'
import React from 'react'
import { TemplateSelectInlineInput } from '@ztechapps/webui.data-tools'
import { purchaseOrderItemRemarksTemplateCategory } from '@ztechapps/purchase-order.common'

type PurchaseOrderItemRemarkInputProps = {
  purchaseOrderId: string
}

export const PurchaseOrderItemRemarkSelectInlineInput = ({
  inputProps,
  displayContent,
  updateParams,
  emptyContent,
  ...rest
}: InlineInputProps<PurchaseOrderItemRemarkInputProps>) => {
  const { purchaseOrderId, ...restInputProps } = inputProps

  emptyContent =
    emptyContent ??
    ((onClick, { canEdit }) => {
      return canEdit && <div>[Add remarks]</div>
    })
  updateParams =
    updateParams ??
    (({ _id, updatedValue }) => {
      return {
        input: {
          remarks: updatedValue?.value ?? updatedValue,
        },
        filter: { 'items._id': _id, _id: purchaseOrderId },
      }
    })
  displayContent =
    displayContent ??
    ((remarks: SelectOption) => {
      return <div>{remarks?.value ? `** ${remarks?.value}` : ((remarks as unknown as string) ?? '')}</div>
    })

  return (
    <TemplateSelectInlineInput
      templateCategory={purchaseOrderItemRemarksTemplateCategory}
      emptyContent={emptyContent}
      updateParams={updateParams}
      displayContent={displayContent}
      inputProps={{ ...restInputProps, isClearable: true, placeholder: 'Select a remark.' }}
      {...rest}
    />
  )
}
